module.exports = __webpack_public_path__ + "img/akfel-wgc-paris-multitouch-application-01.4e870b77.jpg";